module.exports = __webpack_public_path__ + "static/media/result.74356e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/safetyTrainingExam/images/result.png
// module id = 1415
// module chunks = 0